// Librerias
import React from 'react'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './modal.css'
let cx = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalAuditorMasivo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false
        }
        this.confirmar = ()=>{
            this.setState({bloqueado: true})
            let cambiosAuditoria = {}
            cambiosAuditoria.idAuditor = this.props.idAuditorMasivo
            this.props.auditorMultiple(cambiosAuditoria)
                .then(()=>{
                    this.setState({bloqueado: false})
                    this.props.hideModal()
                })
                .catch(err=>{
                    console.error(err.data)
                })

        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal}  dialogClassName={cx('modalConfirmacion')} className={cx('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Favor confirmar la asignación multiple</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>¿Esta seguro de asignar un total de {this.props.totalAuditorias} auditorias a {this.props.auditor? this.props.auditor.nombre1 : 'SIN'} {this.props.auditor? this.props.auditor.apellidoPaterno : 'AUDITOR'}?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary" onClick={this.confirmar} disabled={this.state.bloqueado}>Agregar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/Modales.jsx